export default __webpack_public_path__ + "static/dark-sg-f6d3b375f882b5d10e9c3964e740a66b.svg";